import React, { Component } from 'react';
import {Topic, TextHolder, Footer, ExploreData} from '../../Components/contentHolders/contentHolders.js';





export class ChapterHundredTen extends Component {

  render() {
    return (
      <section className="Content">
        <div className="content-holder-topic">
        <div className="content-holder-inner fade">

        <Topic topicNumber={this.props.topicNumber} topicTitle={this.props.topicTitle} topicText={this.props.topicText} />

        <TextHolder text="This report wouldn't be possible without the help of many contributors - here we say a big thank you to our partners and interviewees." />


        <ExploreData nextChapter={ this.props.nextChapter } />
        <Footer />
        </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/110.js